import React, { Component } from "react";
import { connect } from "react-redux";
import history from "../../../Utils/History";
import {
  comparePlan,
  getcmpNames,
  setFormData,
  setStateParams,
} from "../../../Redux/Actions/webAppActions";
import { Text } from "react-internationalization";
import { LANG } from "../../translations/dynamic";
import { SHARP_CONSTS } from "../../../Utils/StaticData/Constant";
class ComparePlan extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  compare = async (event) => {
    //to be sent to api as request if compare is clicked.
    let plans = [];
    let arr = this.props.compareList;
    let category = this.props.cardDetails.filter(
      (card) => arr.indexOf(card.productId) >= 0
    );
    let categoryArray = [];
    category.forEach((x) => categoryArray.push(x.productCategory));
    let allEqual = categoryArray.every((y) => y === categoryArray[0]);
    if (allEqual === false) {
      let msg2 =
        this.props.lang === "en"
          ? "Please select the product."
          : "Por favor seleccione el producto.";
      this.props.setSnackbar(true, msg2, "error");
      return;
    }
    arr[arr.length] = "0000";
    plans = arr.map((x) => {
      let sort = this.props.cardDetails.filter((card) => card.productId === x);
      return sort[0];
    });

    if (plans.length === 1) {
      let formPayload = {
        planId: plans[0].planId,
        productId: plans[0].productId,
        premiumAmount: plans[0].monthlyPremium,
        planName: plans[0].planName,
      };
      this.props.setFormData(formPayload);
    }
    this.props.getcmpNames(plans);
    window.sessionStorage.setItem("cmpnames", JSON.stringify(plans));
    const list = plans.map((plan) => ({
      customerId: this.props?.customerId,
      planId: plan.planId,
      productId: plan.productId,
      planName: plan.planName,
      planYear: this.props.year,
    }));
    await this.props.setStateParams("isCompare", false);
    await this.props.comparePlan(list);
    history.push("/e-Enroll/compare-plan");
  };

  // Remove plans for comparsion
  removeCompareList = (index) => {
    if (index > -1) {
      // only splice array when item is found
      this.props.compareList.splice(index, 1); // 2nd parameter means remove one item only
      this.props.setStateParams(
        "selectedPlansForCompare",
        this.props.compareList
      );
      this.props.handleCompareList(this.props.compareList);
    } else if (index === "close") {
      this.props.setStateParams("selectedPlansForCompare", []);
      this.props.handleCompareList([]);
    }
  };
  render() {
    const comparingPlan = this.props.cardDetails
      .filter((card) => this.props.compareList.indexOf(card.productId) >= 0)
      .map((plan) =>
        this.props.lang === "es"
          ? plan.planNameES?.toUpperCase()
          : plan.planName?.toUpperCase()
      );
    return (
      <div className="compare-panel">
        <p className="text-white">
          <Text id="sharp.planLimit" />
        </p>
        <button
          type="button"
          className="btn-close close-button filter-invert"
          id="btn_close_compare_panel"
          onClick={() => this.removeCompareList("close")}
        />
        <div className="container-fluid">
          <div className="cards-container">
            {SHARP_CONSTS.COMPARE_PLAN.map((count, index) => (
              <div
                className="card-placeholder card-placeholder-dummy"
                key={count}
              >
                {comparingPlan.length > 0 && comparingPlan[index] && (
                  <div className="card">
                    <button
                      onClick={() => this.removeCompareList(index)}
                      className="btn-close close btn-compare-close"
                    />
                    <h5 className="compare-card-heading">
                      {comparingPlan[index]}
                    </h5>
                  </div>
                )}
              </div>
            ))}

            {/* <div className="card-placeholder card-placeholder-dummy" />
            <div className="card-placeholder card-placeholder-dummy" /> */}
            <div className="plus-placeholder text-center">
              <span className="plus-symbol filter-invert">+</span>
            </div>
            <div className="card-placeholder2">
              <div className="card p-2">
                <p>
                  <Text id="sharp.complareInst" />
                </p>
              </div>
            </div>
            <div className="button-card mt-1">
              <button
                className={
                  "btn btn-shp btn-shp-default btn-compare " +
                  (this.props.compareList.length > 1 ? "" : "filter-invert")
                }
                disabled={this.props.compareList.length > 1 ? false : true}
                onClick={this.compare}
              >
                <Text id="app.compare" />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    year: state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year,
    cardDetails: state.webApp.planCardData,
    zipCode: state.webApp.zip,
    agentLogin: state.login.agentLoggedIn,
    county: state.webApp.county,
    customerId: state.login.customerId,
    selectedProduct: state.webApp.selectedProduct,
    lang: state.webApp.language,
    planType: state.webApp.planType,
    selectedPlansForCompare: state.webApp.selectedPlansForCompare,
  };
};
const mapDispatchToProps = {
  comparePlan,
  getcmpNames,
  setFormData,
  setStateParams,
};

export default connect(mapStateToProps, mapDispatchToProps)(ComparePlan);
